import { Box, CircularProgress } from '@mui/material';
import React from 'react';

/**
 * LoadingFallback Component
 *
 * Loading fallback component for React.Suspense boundaries.
 * Displays a centered loading spinner during lazy component loading.
 *
 * @component
 * @example
 * ```tsx
 * <Suspense fallback={<LoadingFallback />}>
 *   <LazyComponent />
 * </Suspense>
 * ```
 */
export const LoadingFallback: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
      }}>
      <CircularProgress size={60} thickness={4} />
    </Box>
  );
};

export default LoadingFallback;
